.remove-modal {
  width: 480px;
}
